import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout-private/operation/")({
	component: () => <div>Hello /_layout-private/operation/!</div>,
});
